import { render, staticRenderFns } from "./verify-identity.vue?vue&type=template&id=1e4b5684&scoped=true"
import script from "./verify-identity.vue?vue&type=script&lang=js"
export * from "./verify-identity.vue?vue&type=script&lang=js"
import style0 from "./verify-identity.vue?vue&type=style&index=0&id=1e4b5684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b5684",
  null
  
)

export default component.exports